// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Guatemala */
const GT = /^(?:(?:[3-5]\d\d|80[0-4])\d{5})$/;

export default GT;
